import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import SimpleModal from "./SimpleModal";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import _ from "lodash";
import { getSiteParams } from "../../configuration/wizardConfiguration";
import ReactMarkdown from "react-markdown";
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import TextField from "@material-ui/core/TextField";


const Quantity = ({ formData, setFormValues, setForm, stepData, card }) => {
  const { radioGroup } = stepData.params;
  // const { cards } = radioGroup;

  const updateQuantity = (stepData,updatedName, updatedQ) => {
    let updatedFormData = { ...formData };

    if (isNaN(updatedQ) || updatedQ < 0) {
      updatedFormData[updatedName] = 0;
      // updatedFormData[`${radioGroup.name}__code`] = "";
      // updatedFormData[`${radioGroup.name}__price`] = "";
      // updatedFormData[`${radioGroup.name}__description`] = "";
    } else {
      updatedFormData[updatedName] = updatedQ;
      // updatedFormData[`${radioGroup.name}__code`] = radioGroup.code;
      // updatedFormData[`${radioGroup.name}__price`] = radioGroup.price;
      // updatedFormData[`${radioGroup.name}__description`] =
      //   radioGroup.cards[0].description;
    }


    // verifica se quantità totale impostte nel/nei box quantity è maggiore di parametro max
    // se maggiore aggiunge al form un messaggio errore (che non fa proseguire quando clicchi NEXT)
    // altrimenti lo cancella così si può proseguire al NEX
    const maxQuantitySum = stepData.params.radioGroup.maxQuantitySum;
    const key = stepData.params.radioGroup.value;    
    const keyMaxQuantitySumError =  `${key}_max_quantity_error`;

    const toSum = _.filter(_.keys(updatedFormData),function(param) {
          return _.startsWith(param, `${key}_`) && _.endsWith(param, '___qty');
        } )
    
    let currentSum = 0
    _.forEach(toSum, function(value) {
      currentSum += updatedFormData[value];
    });
    
    if (currentSum > maxQuantitySum) {
      const msg = stepData.params.radioGroup.maxQuantityMessage.replace("{{numMax}}",maxQuantitySum);    
      updatedFormData[keyMaxQuantitySumError] = msg;
    } else {
      delete updatedFormData[keyMaxQuantitySumError];  
    }

    // used by summary card
    const labelKey = `${stepData.params.radioGroup.value}_${card.code}___label`;
    updatedFormData[labelKey] = card.label;

    setFormValues({ ...updatedFormData });

  };

  const deltaQuantity = (stepData, key, delta) => {
    // let updatedQ = formData[`${key}_${code}___qty`] + delta;
    // let updatedQ = formData[key] + delta;

    let updatedQ = (isNaN(formData[key])) ? delta : formData[key] + delta;

    updateQuantity(stepData, key,updatedQ);
  };

  // const setQuantity = (e) => {
  //   updateQuantity(e.target.name,parseInt(e.target.value));
  // };
  const setQuantity = (stepData, name, value) => {
    updateQuantity(stepData,name,parseInt(value));
  };

  const key = `${stepData.params.radioGroup.value}_${card.code}___qty`;


  // const currentCardSelected = _.has(formData, `${stepData.params.radioGroup.value}___code`) 
  //                             && formData[`${stepData.params.radioGroup.value}___code`] === card.code
  const currValue = _.has(formData,key) ? formData[key] : 0;
  /*
  
    const { name, options } = radioGroup;
    const { value } = event.target;
    let updatedFormData = { ...formData };

    updatedFormData[name] = event.target.value;

    // se c'è codice item lo mettiamo in formData
    const opt = _.find(options, { value: value });
    if (_.has(opt, "code") && !_.isEmpty(opt.code)) {
      updatedFormData[`${name}___code`] = opt.code;
    }


            disabled={
            !(formData[privacyValue] && formData[privacyValue2]) &&
            siteParams.fill_form_enabled
          }
  
  */
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <IconButton
        // name={`${key}_plus`}     
        color="primary"
        component="span"
        onClick={() => {
          deltaQuantity(stepData,key,-1);
        }}
      >
        <RemoveIcon />
      </IconButton>
      <TextField
        label={radioGroup.quantityLabel}
        name={key}
        value={currValue}
        // onChange={setQuantity}
        onChange={(e) => {
          setQuantity(stepData,e.target.name,e.target.value);
        }}
        margin="normal"
        variant="outlined"
        autoComplete="off"
        type="text"
        style={{ width: 70 }}
        inputProps={{
          min: 0,
          max: 100,
          style: {
            textAlign: "center",
            fontSize: "20px",
          },
        }}

        // inputProps={{ size: "3" }}
      />
      <IconButton
        // name={`${key}_minus`}     
        color="primary"
        component="span"
        onClick={() => {
          deltaQuantity(stepData,key,1);
        }}
      >
        <AddIcon />
      </IconButton>
    </Box>
  );
};

export const CardsRadioGroupWithQuantityStep = (props) => {
  const { formData, stepData, setFormValues } = props;

  const { img_base_url } = getSiteParams();
  const { radioGroup, nbText } = stepData.params;
  const { options } = radioGroup;

  const maxQuantitySum = stepData.params.radioGroup.maxQuantitySum;
  const nbCustomText = nbText ? nbText.replace("{{numMax}}",maxQuantitySum) : ""; 



  const handleChange = (
    radioGroup,
    event,
    formData,
    stepData,
    setFormValues
  ) => {
    const { name, options } = radioGroup;
    const { value } = event.target;
    let updatedFormData = { ...formData };

    updatedFormData[name] = event.target.value;

    // rimuoviamo tutte le quantità impostate
    const toRemove = _.filter(_.keys(updatedFormData),function(param) {
          return _.startsWith(param, `${name}_`) && _.endsWith(param, '___qty');
        } )

    _.forEach(toRemove, function(value) {
      delete updatedFormData[value];
    });


    // const arrayWithoutD = updatedFormData.filter(function (param) {
    //   return param !== 'd';
    // });

    // se c'è codice item lo mettiamo in formData
    const opt = _.find(options, { value: value });
    if (_.has(opt, "code") && !_.isEmpty(opt.code)) {
        updatedFormData[`${name}___code`] = opt.code;
    }
    // se c'è price item lo mettiamo in formData
    if (_.has(opt, "price") && !_.isEmpty(opt.price)) {
      updatedFormData[`${name}___price`] = opt.price;
    }
    // se c'è jumptostep item lo mettiamo in formData
    if (_.has(opt, "jumptostep") && !_.isEmpty(opt.jumptostep)) {
      updatedFormData[`${name}___jumptostep`] = opt.jumptostep;
    }

    updatedFormData[`${name}_${opt.code}___qty`] = 1;
    setFormValues({ ...updatedFormData });

  };

  // if (options.length === 0) {
  //   console.log("vuoto");
  //   navigation.next();
  //   console.log("vuoto");
  // }

  return (
    <FormControl component="fieldset" fullWidth={true}>
      {/* <FormLabel component="legend">Brand</FormLabel> */}
      <RadioGroup
        aria-label={radioGroup.label}
        name={radioGroup.name}
        value={formData[radioGroup.value]}
        // onChange={setForm}
        onChange={(e) => {
          handleChange(radioGroup, e, formData, stepData, setFormValues);
        }}
      >
        {/* Riga items e riga nb */}
        <Grid
          item
          container
          direction="column"
          justify="space-around"
          alignItems="stretch"
        >
          {options.length === 0 ? (
            <Grid
              item
              container
              spacing={1}
              alignContent="center"
              alignItems="flex-start"
              justify="space-around"
            >
              <Box
                display="flex"
                width="50%"
                justifyContent="center"
                m={2}
                px={2}
              >
                <Typography variant="h6" align="center">
                  <ReactMarkdown
                    children={stepData.params.messageUnavailable}
                  />
                </Typography>
              </Box>
            </Grid>
          ) : (
            <Grid
              item
              container
              spacing={1}
              alignContent="center"
              alignItems="flex-start"
              justify="space-around"
            >
              {options.map((card, card_index) => {
                // const props = { title: card.label, content: card.infoText };
                const modal =
                  card.infoText && card.infoText !== "" ? (
                    <SimpleModal
                      {...{ title: card.label, content: card.infoText }}
                    />
                  ) : (
                    ""
                  );

                const nb =
                  card.nbText && card.nbText !== "" ? (
                    <Box
                      display="flex"
                      color="red"
                      width="100%"
                      justifyContent="center"
                      pt={3}
                    >
                      <Typography
                        variant="body1"
                        style={{ fontWeight: 600 }}
                        align="center"
                      >
                        {card.nbText}
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  );
                const imgDisclaimer =
                  card.imgDisclaimer && card.imgDisclaimer !== "" ? (
                    <Typography variant="caption" align="center">
                      {card.imgDisclaimer}
                    </Typography>
                  ) : (
                    ""
                  );

                return (
                  <Grid
                    item
                    container
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    direction="column"
                    spacing={1}
                    key={card_index}
                  >
                    <Grid
                      item
                      container
                      direction="column"
                      justify="flex-end"
                      alignItems="center"
                      className="mediaContainer"
                    >




                      <img
                        src={`${img_base_url}${card.img_src}`}
                        alt={card.img_alt}
                        className="imgTile"
                      />
                    </Grid>
                    <Grid item align="center">
                      {imgDisclaimer}
                      {/* <div>{card.description}</div> */}
                      <div>
                        <Typography variant="subtitle1" align="center">
                          {card.label}
                        </Typography>
                      </div>
                      {/* <FormControlLabel
                        key={card.value}
                        value={card.value}
                        control={<Radio />}
                        label={card.label}
                      /> */}
                      <div>{modal}</div>
                      <div>{nb}</div>
                    </Grid>
                    <Grid item>
                      <Quantity {...{...props, ...{card: card}}} />
                    </Grid>                    
                  </Grid>
                );
              })}
            </Grid>
          )}

          {nbCustomText ? (
            <Grid item align="center">
              <Box
                display="flex"
                color="red"
                width="50%"
                justifyContent="center"
                m={2}
                px={2}
              >
                <Typography variant="h6" align="center">
                  {nbCustomText}
                </Typography>
              </Box>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </RadioGroup>
    </FormControl>
  );
};

// return (
//   <Container maxWidth="md">
//     <FormControl component="fieldset">
//       {/* <FormLabel component="legend">Brand</FormLabel> */}
//       <RadioGroup
//         aria-label={radioGroup.label}
//         name={radioGroup.name}
//         value={formData[radioGroup.value]}
//         onChange={setForm}
//       >
//         {options.map((card, card_index) => {
//           const modal =
//             card.infoText && card.infoText !== "" ? <SimpleModal /> : "";

//           return (
//             <div key={card_index}>
//               <img
//                 src={`${img_base_url}${card.img_src}`}
//                 alt={card.img_alt}
//               />
//               <div>{card.description}</div>
//               <FormControlLabel
//                 key={card.value}
//                 value={card.value}
//                 control={<Radio />}
//                 label={card.label}
//               />
//               <div>{modal}</div>
//             </div>
//           );
//         })}
//       </RadioGroup>
//     </FormControl>
//   </Container>
// );
